import { TextLayer } from '@deck.gl/layers';

import type { ColorRGB, IconMapping, TrainRenderData } from '@/types';

import { characterSet, DEPTH, HUD_PARAMETERS, TEXT_STYLE } from '@/utils/constants/map';
import { makeIconLayer } from '@/utils/helpers/train-simulation/make-icon-layer';

export const createBadgeGroup = (
  idPrefix: string,
  data: TrainRenderData[],
  atlas: string,
  mapping: IconMapping,
  offset: [number, number],
  depth: number,
  getPosition: (d: TrainRenderData) => ColorRGB,
  bgColor: ColorRGB | ((d: TrainRenderData) => ColorRGB),
  getText: (d: TrainRenderData) => string,
  textColor: ColorRGB | ((d: TrainRenderData) => ColorRGB) = [255, 255, 255]
) => {
  return [
    makeIconLayer({
      id: `${idPrefix}-border`,
      data,
      atlas,
      mapping,
      offset,
      size: 23,
      color: [255, 255, 255] as ColorRGB,
      depth: depth + 0.1,
      getPosition,
    }),
    makeIconLayer({
      id: `${idPrefix}-bg`,
      data,
      atlas,
      mapping,
      offset,
      size: 20,
      color: bgColor,
      depth,
      getPosition,
    }),
    new TextLayer<TrainRenderData>({
      id: `${idPrefix}-text`,
      data,
      visible: true,
      getPosition,
      getPixelOffset: offset,
      getText,
      getSize: TEXT_STYLE.size,
      fontWeight: TEXT_STYLE.fontWeight,
      fontFamily: TEXT_STYLE.fontFamily,
      getColor: textColor,
      billboard: true,
      parameters: HUD_PARAMETERS,
      characterSet: characterSet,
      getPolygonOffset: (): [number, number] => [0, DEPTH.TEXT],
      pickable: false,
    }),
  ];
};
